@if (!isMobileView) {
  <div class="container-margin">
    <h2>{{ translationService.getUsersText() }}</h2>
    <div class="actions margin-top-10">
      <a [routerLink]="['/admin/users/create']" class="action-item">
        <button
          type="button"
          mat-raised-button
          extended
          color="accent"
          class="action-button"
        >
          <mat-icon>add</mat-icon>
          {{ translationService.getCreateText() }}
        </button>
      </a>
    </div>
    <div class="margin-top-20">
      <app-user-list></app-user-list>
    </div>
  </div>
} @else {
  <div class="container-margin">
    <h2>{{ translationService.getUsersText() }}</h2>
    <div class="row margin-top-20">
      <button
        mat-raised-button
        extended
        color="accent"
        class="mobile-button"
        (click)="goToCreate()"
      >
        <mat-icon>add</mat-icon>
        {{ translationService.getCreateText() }}
      </button>
    </div>
    <div class="margin-top-20">
      <app-user-list></app-user-list>
    </div>
  </div>
}
